
import AppBrowse from "@/components/browse/Browse.vue";
import Crm from "@/models/crm/crm";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { CrmService } from "@/services/crm-service";
import { DossierService } from "@/services/dossier-service";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import {DossierConfigService} from "@/services";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as Crm[],
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		dataSource(): IBrowseDataSource<Crm> {
			let elem = this;
			return {
				getFullElement: (el:Crm)=>CrmService.get(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: CrmService.getCrm.bind(CrmService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return CrmService.getTotals(view);
				},
				edit(crm: Crm) {
					elem.$router.push({path: `/crm/edit/${crm.ID}`});
				},
				async delete(crm: Crm[]) {
					await CrmService.delete(crm);
					return true;
				},
				addRoute: `/crm/new`,
				browseName: "Crm",
				modelName: "Crm",
				browsePermissions: () => UserConfigService.getPermissionSettings().CrmPermissions,
				onSocketElementUpdated: (data: any) => new Crm(data),
				extraFieldSettings: {
					getExtraFields: CrmService.getExtraFields.bind(CrmService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().CrmNames,
					batchEdit: CrmService.batchEditExtraField.bind(CrmService),
					edit: (CrmService.updateExtraFields as any).bind(CrmService)
				}
			};
		},
	},
	async mounted() {
		ToolbarService.title = this.$ct("crm");
		await DossierService.getUsers();
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.crm"
	},
});
